import React from 'react';
import * as Sentry from '@sentry/browser';
import { Message, Icon, Button } from 'semantic-ui-react';
import UserContext from 'contexts/UserContext';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errorType: null,
      eventId: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    let errorType = '500';
    if (error.graphQLErrors && error.graphQLErrors.length > 0 && error.graphQLErrors[0].errorType === "Unauthorized") {
      errorType = 'Unauthorized';
    }
    return { errorType };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV === 'production') {
      Sentry.withScope((scope) => {
        scope.setExtras(info);
        const eventId = Sentry.captureException(error);
        this.setState({eventId});
      });
    }
    console.error(error);
    console.error(info);
  }

  render() {

    const { errorType, eventId } = this.state;

    if ( errorType === 'Unauthorized' ) {
      return (
        <div style={{marginTop: 40}}>
          <Message negative icon>
            <Icon name="ban"/>
            <Message.Header>You are not authorized to view this page.</Message.Header>
          </Message>
          <p style={{textAlign: 'center'}}><a href="/">Return home</a></p>
        </div>
      )
    }
    if (errorType) {
      return (
        <div style={{marginTop: 40, textAlign: 'center'}}>
          <h2>Uh oh. Something went wrong</h2>
          <p>
            Please tell us what happened in order to make Know My Day better!
          </p>
          <div style={{margin: '1em'}}>
            <Button
              color="teal"
              onClick={() => Sentry.showReportDialog({ eventId })}>Send Error Report</Button>
          </div>
          <img alt="500 error" src="http://knowmyday.com/assets/images/500.png" width={300} />
          <p>Go back to <a href="/">Know My Day</a></p>
        </div>
      )
    }

    return this.props.children;
  }
}
ErrorBoundary.contextType = UserContext;

export default ErrorBoundary;
